import { useIntl } from 'react-intl';
import Link from 'client/components/aria/Link/Link';

const ErrorSummary = ({ errors }) => {
    const intl = useIntl();

    const handleClick = (id) => {
        const element = document.getElementById(id);
        if (element) {
            element.scrollIntoView({ behavior: 'smooth', block: 'end' });
            element.focus();
        }
    };

    return (
        <div className="govuk-error-summary" data-module="govuk-error-summary" id="errorSummary">
            <div role="alert">
                <h2 className="govuk-error-summary__title">
                    {intl.formatMessage({ id: 'ErrorSummary.Problem' })}
                </h2>
                <div className="govuk-error-summary__body">
                    <ul className="govuk-list govuk-error-summary__list">
                        {errors.map((error, index) => (
                            <li key={index}>
                                <Link onClick={() => handleClick(error.id)} isError={true} data-testid={error.id + '-errorSummaryItem'}>
                                    {error.message}
                                </Link>
                            </li>
                        ))}
                    </ul>
                </div>
            </div>
        </div>
    );
};

export default ErrorSummary;
